var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',[_c('BaseHero',{class:_vm.$style.mainHeading,attrs:{"text":"Favorite Mixes"}}),_c('BaseContent',[_c('BaseSection',{attrs:{"padded":""}},[_c('MixTableBlock',{attrs:{"mixes":_vm.mixesList,"error":{
          title: "You have not favorited any mixes",
          paragraph:
            "When you press the heart icon on a mix, they will appear here",
        },"should-transition":_vm.shouldTransition,"genres":"","is-indexed-list":""}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }